import Keycloak from 'keycloak-js'

const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_API_SERVER_AUTH_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM_NAME,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID
})

export default keycloak
